// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Polygon Popup Modal Styles
 *
 * Follows the centrally managed theme system using CSS variables from theme.css
 */

/* Overlay */
.polygon-modal__overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cfn-bg-overlay);
  z-index: 1000;
  padding: 1rem;
}

/* Container */
.polygon-modal__container {
  background: var(--cfn-modal-bg);
  border: 1px solid var(--cfn-border);
  border-radius: 16px;
  box-shadow: var(--cfn-modal-shadow);
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.polygon-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
}

.polygon-modal__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--cfn-text-primary);
}

.polygon-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--cfn-text-muted);
  cursor: pointer;
  transition: all 0.15s ease;
}

.polygon-modal__close:hover {
  background: var(--cfn-bg-elevated);
  color: var(--cfn-text-primary);
}

/* Content */
.polygon-modal__content {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1;
}

/* Action Buttons */
.polygon-modal__actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  margin-bottom: 1rem;
}

.polygon-modal__action-btn {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.65rem 0.85rem;
  background: var(--cfn-bg-tertiary);
  border: 1px solid var(--cfn-border);
  border-radius: 8px;
  color: var(--cfn-text-primary);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.polygon-modal__action-btn:hover {
  background: var(--cfn-bg-elevated);
  border-color: var(--cfn-accent-primary);
}

.polygon-modal__action-btn svg {
  flex-shrink: 0;
  color: var(--cfn-text-muted);
}

.polygon-modal__action-btn:hover svg {
  color: var(--cfn-accent-primary);
}

.polygon-modal__action-btn--danger {
  border-color: var(--cfn-danger-muted);
}

.polygon-modal__action-btn--danger:hover {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-danger);
}

.polygon-modal__action-btn--danger:hover svg {
  color: var(--cfn-danger);
}

/* Properties Table */
.polygon-modal__properties {
  margin-bottom: 1rem;
  max-height: 250px;
  overflow-y: auto;
}

.polygon-modal__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.polygon-modal__table th,
.polygon-modal__table td {
  padding: 0.4rem 0.5rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  text-align: left;
  vertical-align: top;
}

.polygon-modal__table th {
  font-weight: 600;
  color: var(--cfn-text-muted);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  width: 40%;
}

.polygon-modal__table td {
  color: var(--cfn-text-primary);
  word-break: break-word;
}

.polygon-modal__table tr:last-child th,
.polygon-modal__table tr:last-child td {
  border-bottom: none;
}

/* Footer Actions */
.polygon-modal__footer {
  display: flex;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--cfn-border-muted);
}

/* Buttons */
.polygon-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}

.polygon-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.polygon-modal__btn--primary {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-btn-primary-border);
  color: var(--cfn-btn-primary-text);
}

.polygon-modal__btn--primary:hover:not(:disabled) {
  background: var(--cfn-btn-primary-hover-bg);
}

.polygon-modal__btn--secondary {
  background: var(--cfn-btn-secondary-bg);
  border-color: var(--cfn-btn-secondary-border);
  color: var(--cfn-btn-secondary-text);
}

.polygon-modal__btn--secondary:hover:not(:disabled) {
  background: var(--cfn-btn-secondary-hover-bg);
}

.polygon-modal__btn--warning {
  background: var(--cfn-btn-warning-bg);
  border-color: var(--cfn-btn-warning-border);
  color: var(--cfn-btn-warning-text);
}

.polygon-modal__btn--warning:hover:not(:disabled) {
  background: var(--cfn-btn-warning-hover-bg);
}

.polygon-modal__btn--danger {
  background: var(--cfn-btn-danger-bg);
  border-color: var(--cfn-btn-danger-border);
  color: var(--cfn-btn-danger-text);
}

.polygon-modal__btn--danger:hover:not(:disabled) {
  background: var(--cfn-btn-danger-hover-bg);
}

.polygon-modal__btn--full {
  width: 100%;
}

/* Form Styles */
.polygon-modal__form {
  min-width: 280px;
}

.polygon-modal__form-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--cfn-border-muted);
}

.polygon-modal__form-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--cfn-text-primary);
}

.polygon-modal__back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: var(--cfn-bg-tertiary);
  border: 1px solid var(--cfn-border);
  border-radius: 8px;
  color: var(--cfn-text-primary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.polygon-modal__back-btn:hover {
  background: var(--cfn-bg-elevated);
  border-color: var(--cfn-accent-primary);
}

.polygon-modal__field {
  margin-bottom: 1rem;
}

.polygon-modal__field label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--cfn-text-secondary);
  margin-bottom: 0.4rem;
}

.polygon-modal__field--checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.polygon-modal__field--checkbox label {
  margin-bottom: 0;
  font-weight: 500;
}

.polygon-modal__input,
.polygon-modal__select {
  width: 100%;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-input-border);
  border-radius: 8px;
  color: var(--cfn-input-text);
  transition: all 0.15s ease;
}

.polygon-modal__input:focus,
.polygon-modal__select:focus {
  outline: none;
  border-color: var(--cfn-input-focus-border);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);
}

.polygon-modal__input::-moz-placeholder {
  color: var(--cfn-input-placeholder);
}

.polygon-modal__input::placeholder {
  color: var(--cfn-input-placeholder);
}

.polygon-modal__checkbox {
  width: 1.1rem;
  height: 1.1rem;
  accent-color: var(--cfn-accent-primary);
}

.polygon-modal__error {
  color: var(--cfn-danger-text);
  font-size: 0.8rem;
  margin-bottom: 1rem;
  padding: 0.6rem;
  background: var(--cfn-danger-muted);
  border-radius: 6px;
}

.polygon-modal__success {
  color: var(--cfn-success-text, #166534);
  font-size: 0.8rem;
  margin-bottom: 1rem;
  padding: 0.6rem;
  background: var(--cfn-success-muted, #dcfce7);
  border-radius: 6px;
}

/* Confirm Dialog */
.polygon-modal__confirm {
  min-width: 280px;
}

.polygon-modal__confirm-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 1rem;
  color: var(--cfn-warning);
}

.polygon-modal__confirm-message {
  color: var(--cfn-text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1.25rem;
  line-height: 1.5;
}

.polygon-modal__confirm-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/components/modals/polygon-popup-modal.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,aAAa;AACf;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAFA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":["/**\n * Polygon Popup Modal Styles\n *\n * Follows the centrally managed theme system using CSS variables from theme.css\n */\n\n/* Overlay */\n.polygon-modal__overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--cfn-bg-overlay);\n  z-index: 1000;\n  padding: 1rem;\n}\n\n/* Container */\n.polygon-modal__container {\n  background: var(--cfn-modal-bg);\n  border: 1px solid var(--cfn-border);\n  border-radius: 16px;\n  box-shadow: var(--cfn-modal-shadow);\n  width: 100%;\n  max-width: 400px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.polygon-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n}\n\n.polygon-modal__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n}\n\n.polygon-modal__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: var(--cfn-text-muted);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.polygon-modal__close:hover {\n  background: var(--cfn-bg-elevated);\n  color: var(--cfn-text-primary);\n}\n\n/* Content */\n.polygon-modal__content {\n  padding: 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Action Buttons */\n.polygon-modal__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  margin-bottom: 1rem;\n}\n\n.polygon-modal__action-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.65rem 0.85rem;\n  background: var(--cfn-bg-tertiary);\n  border: 1px solid var(--cfn-border);\n  border-radius: 8px;\n  color: var(--cfn-text-primary);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.polygon-modal__action-btn:hover {\n  background: var(--cfn-bg-elevated);\n  border-color: var(--cfn-accent-primary);\n}\n\n.polygon-modal__action-btn svg {\n  flex-shrink: 0;\n  color: var(--cfn-text-muted);\n}\n\n.polygon-modal__action-btn:hover svg {\n  color: var(--cfn-accent-primary);\n}\n\n.polygon-modal__action-btn--danger {\n  border-color: var(--cfn-danger-muted);\n}\n\n.polygon-modal__action-btn--danger:hover {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-danger);\n}\n\n.polygon-modal__action-btn--danger:hover svg {\n  color: var(--cfn-danger);\n}\n\n/* Properties Table */\n.polygon-modal__properties {\n  margin-bottom: 1rem;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.polygon-modal__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.polygon-modal__table th,\n.polygon-modal__table td {\n  padding: 0.4rem 0.5rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  text-align: left;\n  vertical-align: top;\n}\n\n.polygon-modal__table th {\n  font-weight: 600;\n  color: var(--cfn-text-muted);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  width: 40%;\n}\n\n.polygon-modal__table td {\n  color: var(--cfn-text-primary);\n  word-break: break-word;\n}\n\n.polygon-modal__table tr:last-child th,\n.polygon-modal__table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Footer Actions */\n.polygon-modal__footer {\n  display: flex;\n  gap: 0.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--cfn-border-muted);\n}\n\n/* Buttons */\n.polygon-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.polygon-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.polygon-modal__btn--primary {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-btn-primary-border);\n  color: var(--cfn-btn-primary-text);\n}\n\n.polygon-modal__btn--primary:hover:not(:disabled) {\n  background: var(--cfn-btn-primary-hover-bg);\n}\n\n.polygon-modal__btn--secondary {\n  background: var(--cfn-btn-secondary-bg);\n  border-color: var(--cfn-btn-secondary-border);\n  color: var(--cfn-btn-secondary-text);\n}\n\n.polygon-modal__btn--secondary:hover:not(:disabled) {\n  background: var(--cfn-btn-secondary-hover-bg);\n}\n\n.polygon-modal__btn--warning {\n  background: var(--cfn-btn-warning-bg);\n  border-color: var(--cfn-btn-warning-border);\n  color: var(--cfn-btn-warning-text);\n}\n\n.polygon-modal__btn--warning:hover:not(:disabled) {\n  background: var(--cfn-btn-warning-hover-bg);\n}\n\n.polygon-modal__btn--danger {\n  background: var(--cfn-btn-danger-bg);\n  border-color: var(--cfn-btn-danger-border);\n  color: var(--cfn-btn-danger-text);\n}\n\n.polygon-modal__btn--danger:hover:not(:disabled) {\n  background: var(--cfn-btn-danger-hover-bg);\n}\n\n.polygon-modal__btn--full {\n  width: 100%;\n}\n\n/* Form Styles */\n.polygon-modal__form {\n  min-width: 280px;\n}\n\n.polygon-modal__form-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n}\n\n.polygon-modal__form-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n}\n\n.polygon-modal__back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: var(--cfn-bg-tertiary);\n  border: 1px solid var(--cfn-border);\n  border-radius: 8px;\n  color: var(--cfn-text-primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.polygon-modal__back-btn:hover {\n  background: var(--cfn-bg-elevated);\n  border-color: var(--cfn-accent-primary);\n}\n\n.polygon-modal__field {\n  margin-bottom: 1rem;\n}\n\n.polygon-modal__field label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--cfn-text-secondary);\n  margin-bottom: 0.4rem;\n}\n\n.polygon-modal__field--checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.polygon-modal__field--checkbox label {\n  margin-bottom: 0;\n  font-weight: 500;\n}\n\n.polygon-modal__input,\n.polygon-modal__select {\n  width: 100%;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-input-border);\n  border-radius: 8px;\n  color: var(--cfn-input-text);\n  transition: all 0.15s ease;\n}\n\n.polygon-modal__input:focus,\n.polygon-modal__select:focus {\n  outline: none;\n  border-color: var(--cfn-input-focus-border);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);\n}\n\n.polygon-modal__input::placeholder {\n  color: var(--cfn-input-placeholder);\n}\n\n.polygon-modal__checkbox {\n  width: 1.1rem;\n  height: 1.1rem;\n  accent-color: var(--cfn-accent-primary);\n}\n\n.polygon-modal__error {\n  color: var(--cfn-danger-text);\n  font-size: 0.8rem;\n  margin-bottom: 1rem;\n  padding: 0.6rem;\n  background: var(--cfn-danger-muted);\n  border-radius: 6px;\n}\n\n.polygon-modal__success {\n  color: var(--cfn-success-text, #166534);\n  font-size: 0.8rem;\n  margin-bottom: 1rem;\n  padding: 0.6rem;\n  background: var(--cfn-success-muted, #dcfce7);\n  border-radius: 6px;\n}\n\n/* Confirm Dialog */\n.polygon-modal__confirm {\n  min-width: 280px;\n}\n\n.polygon-modal__confirm-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--cfn-warning);\n}\n\n.polygon-modal__confirm-message {\n  color: var(--cfn-text-secondary);\n  font-size: 0.9rem;\n  margin-bottom: 1.25rem;\n  line-height: 1.5;\n}\n\n.polygon-modal__confirm-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
